<div class="picker" dir="rtl">
  <div class="picker-title">
    <span class="icon">💬</span>
    בחר/י שיחה
  </div>

  <div class="picker-list">
    @for (room of sortedRooms; track room.id) {
      <div class="room-row" (click)="onSelect(room)">
        <div class="avatar">
          <span>💬</span>
        </div>
        <div class="room-info">
          <div class="row-top">
            <span class="room-name" [ngClass]="{ unread: room.unreadCount > 0 }">{{ room.name }}</span>
            <span class="room-time" [ngClass]="{ unread: room.unreadCount > 0 }">{{ formatTime(room.last_activity) }}</span>
          </div>
          <div class="row-bottom">
            <span class="last-message" [ngClass]="{ unread: room.unreadCount > 0 }">
              {{ room.lastMessage || 'אין הודעות' }}
            </span>
            @if (room.unreadCount > 0) {
              <span class="unread-badge">{{ room.unreadCount }}</span>
            }
          </div>
        </div>
        <button class="delete-btn" (click)="onDelete($event, room)" title="מחק שיחה">🗑</button>
      </div>
    }
  </div>
</div>
